var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1C0.5 0.447716 0.947715 0 1.5 0H6.5L6.5 4C6.5 4.55228 6.94772 5 7.5 5L11.5 5L11.5 13C11.5 13.5523 11.0523 14 10.5 14L1.5 14C0.947716 14 0.5 13.5523 0.5 13V1ZM3.7 7H2.5V8H3.7V7ZM9.5 7H4.9V8H9.5V7ZM3.7 9H2.5V10H3.7V9ZM9.5 9H4.9V10H9.5V9ZM2.5 11H3.7V12H2.5V11ZM4.9 11H9.5V12H4.9V11Z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0172 4L7.5 4V0.482842C7.5 0.304661 7.71543 0.215428 7.84142 0.34142L11.1586 3.65858C11.2846 3.78457 11.1953 4 11.0172 4Z",
    fill: "#2F80ED"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBlue);
export default __webpack_public_path__ + "static/media/file_blue.b87a1554.svg";
export { ForwardRef as ReactComponent };